import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const usePoultryLoss = (refetch: () => void) => {
  const [isLossDialogOpen, setIsLossDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const cleanNumericValue = (value: string | number): number => {
    if (typeof value === 'number') return value;
    return parseFloat(value.replace(/[^\d.-]/g, ''));
  };

  const handleLossClick = (item: any) => {
    console.log("Loss click - Setting selected item:", item);
    setSelectedItem(item);
    setIsLossDialogOpen(true);
  };

  const handleLossConfirm = async (
    quantity: number, 
    selectedProductId: string, 
    explanation: string,
    proofUrl?: string
  ) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Non authentifié");

      const stockItem = selectedItem;
      if (!stockItem) throw new Error("Produit non trouvé");

      const unitPrice = stockItem.data && typeof stockItem.data === 'object' && 'price' in stockItem.data
        ? cleanNumericValue(stockItem.data.price as string)
        : 0;

      // First, create the transaction
      const { data: transaction, error: transactionError } = await supabase
        .from('poultry_transactions')
        .insert({
          stock_item_id: selectedProductId,
          transaction_type: 'loss',
          quantity: quantity,
          unit_price: unitPrice,
          total_amount: unitPrice * quantity,
          transaction_date: new Date().toISOString(),
          created_by: user.id,
          notes: explanation + (proofUrl ? ` [proof_url:${proofUrl}]` : '')
        })
        .select()
        .single();

      if (transactionError) throw transactionError;

      // Then, update the stock quantity
      const { error: updateError } = await supabase
        .from('stock_items')
        .update({ quantity: stockItem.quantity - quantity })
        .eq('id', selectedProductId);

      if (updateError) throw updateError;

      toast.success("Perte enregistrée avec succès");
      setIsLossDialogOpen(false);
      setSelectedItem(null);
      refetch();
    } catch (error: any) {
      console.error("Erreur lors de l'enregistrement de la perte:", error);
      toast.error(error.message || "Erreur lors de l'enregistrement de la perte");
    }
  };

  return {
    isLossDialogOpen,
    setIsLossDialogOpen,
    selectedItem,
    handleLossClick,
    handleLossConfirm
  };
};